import React from 'react';
import { cn } from '../lib/utils';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'medium',
  fullWidth = false,
  children,
  className,
  ...props
}) => {
  return (
    <button
      className={cn(
        'inline-flex items-center justify-center gap-2',
        'border-none rounded-xl font-semibold',
        'transition-all duration-200 cursor-pointer',
        'active:scale-[0.98]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'tracking-wide',
        // Variants
        variant === 'primary' && 'bg-gradient-primary text-white shadow-button',
        variant === 'secondary' && 'bg-tg-secondary-bg text-tg-text border border-black/5',
        // Sizes
        size === 'small' && 'px-3.5 py-2 text-sm leading-5',
        size === 'medium' && 'px-4.5 py-3 text-[15px] leading-5',
        size === 'large' && 'px-5.5 py-3.5 text-base leading-6',
        // Full width
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}; 